import type { ReactNode } from 'react';

export const symbol_align_self_stretch: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-80q-12.75 0-21.37-8.68Q80-97.35 80-110.18q0-12.82 8.63-21.32Q97.25-140 110-140h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q862.75-80 850-80H110Zm350-190q-12.75 0-21.37-8.63Q430-287.25 430-300v-380q0-12.75 8.63-21.38Q447.25-710 460-710h40q12.75 0 21.38 8.62Q530-692.75 530-680v380q0 12.75-8.62 21.37Q512.75-270 500-270h-40ZM110-820q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-880 110-880h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Z"
		/>
	</svg>
);
